import { Component, OnInit } from '@angular/core';
import { AppGlobalsService } from '../app-globals.service';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.css']
})
export class AccessibilityComponent implements OnInit {

  constructor(private appGlobalsSvc: AppGlobalsService) { }

  ngOnInit(): void {
  }

  openContactForm() {
    this.appGlobalsSvc.openContactRequest('Contact Us');
  }

}
